import * as Yup from 'yup';
import { useMemo } from 'react';
import { isEmpty, orderBy } from 'lodash';
import { Form } from '@/components';
import { FormHomeDeadlineItem } from './FormHomeDeadlineItem';
import { ProjectHomeStepDeadlineLookupDto } from '@/core';

interface Props {
  steps: ProjectHomeStepDeadlineLookupDto[];
  onSubmit: (value: any) => any;
}

const SCHEMA = Yup.object().shape({
  steps: Yup.array()
    .of(
      Yup.object().shape({
        initialDate: Yup.date().nullable(),
        deadlineDate: Yup.date().nullable().defined(),
      }),
    )
    .required(),
});

function useInitialValue(steps: ProjectHomeStepDeadlineLookupDto[]) {
  return useMemo(
    () => ({
      steps: steps.map((step) => ({
        id: step.id,
        index: step.index,
        name: step.name,
        deadlineDate: step.deadlineDate,
        initialDate: step.deadlineDate,
      })),
    }),
    [steps],
  );
}

export const FormHomeDeadlines = (props: Props) => {
  const { steps: stepsProp, onSubmit } = props;

  const steps = useMemo(() => orderBy(stepsProp, (x) => x.index), [stepsProp]);
  const initialValues = useInitialValue(steps);

  if (isEmpty(steps)) {
    return null;
  }

  return (
    <Form.Formik<ReturnType<typeof useInitialValue>>
      uid="home-deadlines"
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={SCHEMA}
      i18n="projects"
    >
      {steps.map((step) => (
        <FormHomeDeadlineItem key={step.index} name={`steps[${step.index}]`} />
      ))}
    </Form.Formik>
  );
};
